import { combineReducers } from 'redux';
import { takeEvery, call, select } from 'redux-saga/effects';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';

export const FETCH_COMPANY_POSITIONS = 'company-positions/FETCH_COMPANY_POSITIONS';

const companyPositionsListReducer = (state = [], action) => {
    switch (action.type) {
        case actionKey.success(FETCH_COMPANY_POSITIONS):
            return action.payload.positions;
        default:
            return state;
    }
};

const loadingReducer = (state = false, action) => {
    switch (action.type) {
        case actionKey.init(FETCH_COMPANY_POSITIONS):
            return true;
        case actionKey.failure(FETCH_COMPANY_POSITIONS):
        case actionKey.success(FETCH_COMPANY_POSITIONS):
            return false;
        default:
            return state;
    }
};

const errorReducer = (state = null, action) => {
    switch (action.type) {
        case FETCH_COMPANY_POSITIONS:
        case actionKey.success(FETCH_COMPANY_POSITIONS):
            return null;
        case actionKey.failure(FETCH_COMPANY_POSITIONS):
            return action.error;
        default:
            return state;
    }
};

export default combineReducers({
    companyPositionsList: companyPositionsListReducer,
    loading: loadingReducer,
    error: errorReducer,
});

export const fetchCompanyPositionsAction = ({ reject, resolve } = {}) => ({
    type: FETCH_COMPANY_POSITIONS,
    reject,
    resolve,
});

export function* rootSaga() {
    yield takeEvery(FETCH_COMPANY_POSITIONS, fetchCompanyPositions);
}

const noop = () => null;

function* fetchCompanyPositions({ type, reject = noop, resolve = noop }) {
    const { positions } = yield select();
    if (positions.loading || positions.companyPositionsList.length !== 0) {
        resolve({ positions: positions.companyPositionsList });
        return;
    }

    const res = yield call(request, {
        url: '/api/company-positions',
        type,
        options: {
            method: 'GET',
        },
    });

    if (res.error && reject) {
        reject(res.error);
    } else if (!res.error && resolve) {
        resolve(res.payload);
    }
}



// WEBPACK FOOTER //
// ./src/client/redux/company-positions.js